import { gettext } from '@eventbrite/i18n';
import React from 'react';
import IconButton from '../../iconButton/IconButton';
import MinusChunkySvg from '../../iconography/icons/MinusChunky';
import PlusChunkySvg from '../../iconography/icons/PlusChunky';
import ZoomToFit from '../../iconography/icons/ZoomToFit';
import './zoom.scss';

interface IZoom {
    buttons: {
        zoomIn: {
            enabled: boolean;
            handler: () => void;
        };
        zoomOut: {
            enabled: boolean;
            handler: () => void;
        };
        zoomToFit: {
            enabled: boolean;
            handler: () => void;
        };
    };
}

const Zoom = ({ buttons }: IZoom): React.ReactElement => {
    const { zoomIn, zoomOut, zoomToFit } = buttons;

    return (
        <div
            className="zoom-buttons-container"
            data-testid="zoom-buttons-container"
        >
            {zoomIn && zoomIn.enabled ? (
                <IconButton
                    iconType={<PlusChunkySvg />}
                    title={gettext('Zoom in')}
                    onClick={zoomIn.handler}
                    style="outline"
                    iconSize="xsmall"
                    data-testid="zoom-in-button"
                />
            ) : undefined}
            {zoomOut && zoomOut.enabled ? (
                <IconButton
                    iconType={<MinusChunkySvg />}
                    title={gettext('Zoom out')}
                    onClick={zoomOut.handler}
                    style="outline"
                    iconSize="xsmall"
                    data-testid="zoom-out-button"
                />
            ) : undefined}

            {zoomToFit && zoomToFit.enabled ? (
                <IconButton
                    iconType={<ZoomToFit />}
                    title={gettext('Zoom to fit')}
                    onClick={zoomToFit.handler}
                    style="outline"
                    iconSize="xsmall"
                    data-testid="zoom-fit-button"
                />
            ) : undefined}
        </div>
    );
};

export default Zoom;
